import { render, staticRenderFns } from "./ObjectForm.vue?vue&type=template&id=b073055a&scoped=true"
import script from "./ObjectForm.vue?vue&type=script&lang=js"
export * from "./ObjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b073055a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b073055a')) {
      api.createRecord('b073055a', component.options)
    } else {
      api.reload('b073055a', component.options)
    }
    module.hot.accept("./ObjectForm.vue?vue&type=template&id=b073055a&scoped=true", function () {
      api.rerender('b073055a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ObjectForm.vue"
export default component.exports